// extracted by mini-css-extract-plugin
export default {"heading-style":"styles_heading-style__mCJqT","cell-title":"styles_cell-title__oef1w"};